import React from 'react';

const LanguageContext = React.createContext({});

export const useTextResources = () => {
    const context = React.useContext(LanguageContext);

    return React.useCallback(
        (key) => {
            if (context?.texts) {
                if (context.texts[key]) {
                    return context.texts[key];
                }
                else {
                    console.warn(`Text resource not found for: ${key}`);
                    return `[${key}]`;
                }
            }
            // Fallback in case context is not available when mixing react and non-react code
            else if (window.optima?.resourceManager){
               if (window.optima.resourceManager.texts && window.optima.resourceManager.texts[key]) {
                    return window.optima.resourceManager.texts[key];
                }
                else {
                    console.warn(`Text resource not found for: ${key}`);
                    return `[${key}]`;
                }
            }
            else {
                return `[${key}]`;
            }
        },
        [context]
    );
};

// Resolve a text resource, falling back to readable English until the localization
// entry is added to the central resource set (useTextResources returns "[key]" for a
// missing key). Once EN+HE values exist for the key, the real value is used automatically.
export const useTextOr = () => {
    const text = useTextResources();

    return React.useCallback(
        (key, fallback) => {
            const resolved = text(key);
            return resolved === `[${key}]` ? fallback : resolved;
        },
        [text]
    );
};

export const useMessageResources = () => {
    const context = React.useContext(LanguageContext);

    return React.useCallback(
        (key) => {
            if (context?.messages) {
                if (context.messages[key]) {
                    return context.messages[key];
                }
                 else {
                    console.warn(`Message resource not found for: ${key}`);
                    return `[${key}]`;
                }
            } 
            // Fallback in case context is not available when mixing react and non-react code
            else if (window.optima?.resourceManager){
               if (window.optima.resourceManager.messages && window.optima.resourceManager.messages[key]) {
                    return window.optima.resourceManager.messages[key];
                }
                else {
                    console.warn(`Message resource not found for: ${key}`);
                    return `[${key}]`;
                }
            }
            else {
                console.warn(`Resource not found for: ${key}`);
                return key;
            }
        },
        [context]
    );
};

export default LanguageContext;
